import { render, staticRenderFns } from "./OrmMessageNewSideMenu.vue?vue&type=template&id=a1249cf8"
import script from "./OrmMessageNewSideMenu.vue?vue&type=script&lang=js"
export * from "./OrmMessageNewSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports